import * as React from "react";
const SvgOtherVerticalFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4", clipRule: "evenodd" }));
export default SvgOtherVerticalFill;
